/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { buildData } from '../helpers/dataHelpers';
import assetModel from './asset';

function getAssets(items) {
  return buildData(items, assetModel);
}

const collection = ({
  id,
  title,
  blogLink,
  blogSummary,
  description,
  tags = [],
  imageUrl,
  assets: rawAsset,
  status,
  weight,
  createdAt,
  updatedAt,
}) => {
  const assets = getAssets(rawAsset);

  return {
    id,
    title,
    blogLink,
    blogSummary,
    description,
    tags,
    imageUrl,
    assets: assets,
    status,
    weight,
    createdAt,
    updatedAt,
  };
};

export default collection;
